import * as React from 'react';

import PropTypes from 'prop-types';
import type { LegacyContextType } from 'types/legacy-context-types';

import { setActiveWalletId } from 'bundles/account-settings/actions/EnterCardFormActions';
import SettingsActionCreators from 'bundles/account-settings/actions/SettingsActionCreators';
import SaveLink from 'bundles/account-settings/components/common/SaveLink';
import StatusMessage from 'bundles/account-settings/components/common/StatusMessage';
import { UpdateStates } from 'bundles/account-settings/constants/SettingsConstants';
import type PaymentWalletsV1 from 'bundles/naptimejs/resources/paymentWallets.v1';
import TrackedButton from 'bundles/page/components/TrackedButton';
import PaymentProcessorTypes from 'bundles/payments/common/PaymentProcessorTypes';

import _t from 'i18n!nls/account-settings';

import 'css!./__styles__/CurrentWallet';

type Props = {
  updateStatusDelete: {
    state: string;
  };
  wallet: PaymentWalletsV1;
  activeWalletId: number | null | undefined;
  showEditButton?: boolean;
};

class CurrentWallet extends React.Component<Props> {
  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
  };

  declare context: LegacyContextType<typeof CurrentWallet.contextTypes>;

  handleDeleteCard = () => {
    const { wallet } = this.props;
    SettingsActionCreators.showDeleteCreditCardModal(wallet.id);
  };

  handleEditCard = () => {
    const { executeAction } = this.context;
    const { wallet } = this.props;
    executeAction(setActiveWalletId, wallet.id);
  };

  renderCreditCardSection = () => {
    const { wallet, showEditButton } = this.props;
    const { creditCardLastFourDigits, id } = wallet;
    const creditCardNumber = `XXXX-XXXX-XXXX-${creditCardLastFourDigits || 'XXXX'}`;
    const creditCardId = `settings-creditcard-${id}`;

    return (
      <div className="settings-input-wrapper">
        <label className="label" htmlFor={creditCardId}>
          {_t('Credit Card')}
        </label>

        <div>
          <input
            type="text"
            id={creditCardId}
            className="settings-creditcard"
            defaultValue={creditCardNumber}
            disabled={true}
          />

          {showEditButton && (
            <TrackedButton
              trackingName="edit_wallet"
              className="secondary edit-wallet-button"
              onClick={this.handleEditCard}
            >
              {_t('Edit')}
            </TrackedButton>
          )}

          {this.renderDeleteLink()}
        </div>
      </div>
    );
  };

  renderPaypalSection = () => {
    const { wallet } = this.props;
    const { email } = wallet;

    return (
      <div>
        <div className="label">{_t('PayPal Account')}</div>

        <div>
          <span className="settings-paypal">{email}</span>
          {this.renderDeleteLink()}
        </div>
      </div>
    );
  };

  renderDeleteLink() {
    const { updateStatusDelete, activeWalletId, wallet } = this.props;
    return (
      <SaveLink
        onClick={this.handleDeleteCard}
        text={_t('Delete')}
        updating={activeWalletId === wallet.id && updateStatusDelete.state === UpdateStates.UPDATING}
      />
    );
  }

  renderWallet = (paymentProcessorId: string | null | undefined): React.ReactNode => {
    switch (paymentProcessorId) {
      case PaymentProcessorTypes.paypal:
        return this.renderPaypalSection();
      case PaymentProcessorTypes.braintree:
        return this.renderCreditCardSection();
      default:
        return null;
    }
  };

  render() {
    const { wallet, updateStatusDelete } = this.props;
    const { paymentProcessorId } = wallet;

    return (
      <div className="rc-CurrentWallet">
        {this.renderWallet(paymentProcessorId)}
        <StatusMessage status={updateStatusDelete.state} />
      </div>
    );
  }
}

export default CurrentWallet;
